import { Component } from 'react';
import PropTypes from 'prop-types';
import storageAvailable from '../../../helpers/storage_available';
import trackEvent from '../../../helpers/gtm/eventPush';

/**
 * Might be worth extracting this for explicit testing.
 * @param {number} price
 * @param {number} discountPercentage
 */
const getDiscountedTotal = (price, discountPercentage) => {
  const onePercentOfPrice = price / 100;
  const reduction = onePercentOfPrice * discountPercentage;
  return price - reduction;
};

function calculateSubTotal(product_price = 0, extraListings = 0) {
  return parseFloat(product_price) + extraListings;
}

const productExtraListingsMap = {};

class CheckoutCart extends Component {
  constructor(props) {
    super(props);
    this.updateCart = this.updateCart.bind(this);
    this.storeOrderDetails = this.storeOrderDetails.bind(this);
    this.addExtraListings = this.addExtraListings.bind(this);
    this.getExtraListings = this.getExtraListings.bind(this);
    this.getAvailableExtraListings = this.getAvailableExtraListings.bind(this);
    this.updateExtraListingsTotal = this.updateExtraListingsTotal.bind(this);
    this.addDefaultExtraListings = this.addDefaultExtraListings.bind(this);
    this.state = {
      products: [this.getDefaultProduct()],
      total: 0,
      subTotal: 0,
      stripeUrls: this.props.stripeUrls,
      extraListings: 0,
      extraListingsSelectedId: '',
      extraListingsTotal: 0,
    };
    productExtraListingsMap[
      this.props.localisations.four_week_title
    ] = this.props.localisations.four_week_desc;
    productExtraListingsMap[
      this.props.localisations.three_month_title
    ] = this.props.localisations.three_month_desc;
    productExtraListingsMap[
      this.props.localisations.six_month_title
    ] = this.props.localisations.six_month_desc;
    productExtraListingsMap[
      this.props.localisations.one_year_title
    ] = this.props.localisations.one_year_desc;
  }

  componentDidMount() {
    this.getFailedPaymentProducts();
    return this.updateSubTotal();
  }

  componentDidUpdate(prevProps) {
    if (
      !this.getProductFromId(this.state.products[0].id, this.props.products)
    ) {
      const currentProduct =
        this.state.products.find(
          (product) => product.department == this.props.products[0].department,
        ) || this.props.products[0];
      const isCurrentProduct = this.props.products.find(
        (product) => product.id === currentProduct.id,
      );

      if (isCurrentProduct) {
        return this.updateCart(currentProduct);
      }
      return this.updateCart(this.props.products[0]);
    }
    return false;
  }

  getDefaultProduct() {
    return this.props.siteId == 21 &&
      this.props.userType == 'offerer' &&
      this.props.userUpgraded
      ? this.props.products[2]
      : this.props.products[0];
  }

  addDefaultExtraListings() {
    if (
      this.props.siteId == 21 &&
      this.props.userType == 'offerer' &&
      this.props.userUpgraded
    ) {
      const quantity = this.props.numAds > 1 ? this.props.numAds - 1 : 0;
      const selectElem = document.querySelector(
        `#extra_listings option[value="${quantity}"]`,
      );
      if (selectElem) {
        selectElem.value = quantity;
        const { id } = selectElem.dataset;
        this.addExtraListings(quantity, id);
      }
    }
  }

  updateTotal() {
    this.setState({
      total: this.calculateTotal(),
    });
  }

  updateSubTotal() {
    this.setState(
      {
        subTotal: calculateSubTotal(
          this.state.products[0].price,
          this.state.extraListingsTotal,
        ),
      },
      this.updateTotal,
    );
  }

  updateCart(product = {}) {
    this.setState(
      {
        products: [product, ...this.state.products],
      },
      this.updateExtraListingsTotal,
    );
  }

  calculateTotal() {
    return this.props.discounts.percentage
      ? getDiscountedTotal(
          this.state.subTotal,
          parseInt(this.props.discounts.percentage, 10),
        )
      : this.state.subTotal;
  }

  getProductFromId(id, products = this.props.products) {
    return products.find((product) => product.id == id);
  }

  addExtraListings(quantity, id) {
    this.setState(
      {
        extraListings: quantity,
        extraListingsSelectedId: id,
      },

      this.updateExtraListingsTotal,
    );
  }

  getAvailableExtraListings() {
    if (!this.props.extraListings) {
      return null;
    }

    const listingProductsName =
      productExtraListingsMap[this.state.products[0].name];
    if (listingProductsName && this.props.extraListings.length) {
      return this.props.extraListings.filter(
        (listing) => listing.name == listingProductsName,
      );
    }
    return null;
  }

  getExtraListings() {
    const listingProducts = this.getAvailableExtraListings();
    if (!listingProducts) {
      return null;
    }
    const discountThreshold = 10;
    if (this.state.extraListings > discountThreshold) {
      return listingProducts.find(
        (listing) => listing.promotion && listing.promotion.minimum_quantity,
      );
    }
    return listingProducts.find((listing) => !listing.promotion);
  }

  updateExtraListingsTotal() {
    if (!this.props.extraListings) {
      return this.updateSubTotal();
    }

    const extraListing = this.getExtraListings();

    if (extraListing) {
      const updateExtraListingsId =
        this.state.extraListings > 0 ? extraListing.id : '';
      return this.setState(
        {
          extraListingsTotal: extraListing.price * this.state.extraListings,
          extraListingsSelectedId: updateExtraListingsId,
        },
        this.updateSubTotal,
      );
    }
    return this.setState(
      {
        extraListingsTotal: 0,
        extraListings: 0,
        extraListingsSelectedId: '',
      },
      this.updateSubTotal,
    );
  }

  prepareOrderDetails(transactionId) {
    const coupon = {};

    const productDescription = this.props.checkoutCart.product_description;
    const product = this.state.products[0];

    if (this.props.discounts.percentage) {
      coupon.promo_code = this.props.discounts.promo_code
        ? `promo code ${this.props.discounts.promo_code}`
        : 'automatic renewal discount';
      coupon.discount_percentage = this.props.discounts.percentage;
    }

    function getDescription(state) {
      if (productDescription != 'Pro Products') {
        const extraListings =
          state.extraListings && state.extraListingsSelectedId
            ? ` plus ${state.extraListings} extra listing${
                state.extraListings > 1 ? 's' : ''
              }`
            : '';
        return `${productDescription} for ${getDuration(
          product.duration,
        )}${extraListings}`;
      }
      return product.name;
    }

    function getDuration(duration) {
      return typeof duration === 'object' && duration !== null
        ? `${duration.quantity} ${duration.unit}`
        : duration;
    }

    function getCategory() {
      if (productDescription != 'Pro Products') {
        return productDescription.match(
          /(Bold Advertising)|(Early Bird)/,
          'i',
        )[0];
      }
      return 'Pro advertising';
    }

    const orderDetails = {
      transactionId,
      date: Date.now(),
      coupon,
      upgrade: {
        category: getCategory(),
        context: this.props.upgradeContext,
        description: getDescription(this.state),
        value: this.state.total.toFixed(2).toString(),
      },
    };
    if (productDescription == 'Pro Products') {
      orderDetails.upgrade.department = product.department;
    }
    return orderDetails;
  }

  storeOrderDetails(transactionId = '') {
    this.triggerPurchaseTracking();
    const orderDetails = this.prepareOrderDetails(transactionId);
    if (storageAvailable('localStorage')) {
      return localStorage.setItem('purchase', JSON.stringify(orderDetails));
    }
    return false;
  }

  triggerPurchaseTracking() {
    if (this.state.products[0] && this.state.stripeUrls) {
      const successUrl = this.state.stripeUrls.success.split(/.com|co.uk/);
      trackEvent({
        category: 'purchase',
        action: `${this.props.checkoutCart.product_description} ${this.state.products[0].name}_purchase`,
        label: `${this.props.currencySymbol}${
          this.state.products[0].price
        }|${successUrl[1] || this.state.stripeUrls.success}|context=${this.props
          .upgradeContext || 'NULL'}`,
      });
    }
  }

  getFailedPaymentProducts() {
    if (storageAvailable('localStorage')) {
      let failed_purchase = localStorage.getItem('failed_purchase');
      if (failed_purchase) {
        localStorage.removeItem('failed_purchase');
        failed_purchase = JSON.parse(failed_purchase);
        const thirty_minutes = 1000 * 60 * 30;
        if (
          failed_purchase.timestamp &&
          Date.now() - failed_purchase.timestamp < thirty_minutes
        ) {
          const failed_purchase_product = this.props.products.find((product) =>
            failed_purchase.products.some(
              (failed_product) => product.id == failed_product.id,
            ),
          );
          const extra_listings =
            this.props.extraListings &&
            failed_purchase.products.find((failed_product) =>
              this.props.extraListings.some(
                (product) => product.id == failed_product.id,
              ),
            );
          if (failed_purchase_product) {
            this.setState(
              {
                products: [failed_purchase_product],
              },
              () => {
                if (extra_listings) {
                  this.addExtraListings(
                    extra_listings.quantity,
                    extra_listings.id,
                  );
                } else {
                  this.updateSubTotal();
                }
              },
            );
          } else if (extra_listings) {
            this.addExtraListings(extra_listings.quantity, extra_listings.id);
          }
        }
      }
    }
  }

  render() {
    return this.props.render({
      checkoutTotal: this.state.total.toFixed(2).toString(),
      checkoutSubTotal: this.state.subTotal,
      currentProduct: this.state.products[0],
      updateCart: this.updateCart,
      storeOrderDetails: this.storeOrderDetails,
      stripeUrls: this.state.stripeUrls,
      addExtraListings: this.addExtraListings,
      extraListingsCount: this.state.extraListings,
      extraListingsSelectedId: this.state.extraListingsSelectedId,
      extraListingsTotal: this.state.extraListingsTotal,
      availableExtraListings: this.getAvailableExtraListings(),
      addDefaultExtraListings: this.addDefaultExtraListings,
    });
  }
}

CheckoutCart.propTypes = {
  checkoutCart: PropTypes.shape({
    product_description: PropTypes.string,
  }).isRequired,
  discounts: PropTypes.object.isRequired,
  products: PropTypes.array.isRequired,
  render: PropTypes.func.isRequired,
};

export default CheckoutCart;
